const tagType = {
  NULL_ENUM: 0,
  USER_DEFINED: 1,
  PRE_DEFINED: 2,
};

export default tagType;
